import { render, staticRenderFns } from "./ErrorWorkbook.vue?vue&type=template&id=5eedc766&scoped=true"
import script from "./ErrorWorkbook.vue?vue&type=script&lang=js"
export * from "./ErrorWorkbook.vue?vue&type=script&lang=js"
import style0 from "./ErrorWorkbook.vue?vue&type=style&index=0&id=5eedc766&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eedc766",
  null
  
)

export default component.exports